import { commodities, currencies, ipos, mutualFunds, portfolioManagementService, stocks } from "../Helper/svgs";

const ServicesList = [
    {
        icon: stocks,
        title: 'Stocks',
        content: 'Maximize your returns in equity. Trading in short-term and long-term strategy, get daily updates',
    },
    {
        icon: portfolioManagementService,
        title: 'PMS',
        content: '- Value & Growth<br>- ⁠Good Quality Business <br>- ⁠Credible Management <br>- ⁠Sectoral Themes<br>- Use of Derivaties<br>- ⁠Special Situations',
    },
    {
        icon: commodities,
        title: 'COMMODITIES',
        content: '- Low Margin Trading<br>- Trade all Commodities Bullion, Energy & Agro<br>- Trading Tips in all Commoditites',
    },
    {
        icon: currencies,
        title: 'CURRENCY',
        content: 'Best technical analysis in Currency Trade<br>Trade in 4 Currency Pairs<br>- USD/INR<br>- ERU/INR<br>- GBP/INR<br>- JPY/INR'
    },
    {
        icon: ipos,
        title: 'IPOs',
        content: 'Keep an Eye on Markets & apply for IPO<br>- Ongoing IPO<br>- Upcoming IPO',
    },
    {
        icon: mutualFunds,
        title: 'Mutual Funds',
        content: '- Online SIP Plans<br>- Easy steps to Invest in Mutual Funds<br>- Paperless transactions<br>- Tracking of Funds',
    },
]

export default ServicesList;